import { render, staticRenderFns } from "./v80o1020MakePop.vue?vue&type=template&id=2f85259f&scoped=true"
import script from "./v80o1020MakePop.vue?vue&type=script&lang=js"
export * from "./v80o1020MakePop.vue?vue&type=script&lang=js"
import style0 from "./v80o1020MakePop.vue?vue&type=style&index=0&id=2f85259f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85259f",
  null
  
)

export default component.exports